import { RouteRecordRaw } from '@bv/router';

import { mcpBreadcrumbs } from '@/router/main/breadcrumbs';

export const mcpRoute: RouteRecordRaw = {
  path: 'mcp',
  name: 'int-mcp',
  meta: { title: 'integrations.mcp.title_trans', breadcrumbs: mcpBreadcrumbs() },
  component: () => import('@/views/Main/integrations/mcp/McpServer.vue'),
};
